var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tabs" },
    [
      _c(
        "el-tabs",
        {
          attrs: { type: "border-card" },
          on: { "tab-click": _vm.handleTabClick },
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        [
          _c(
            "el-tab-pane",
            {
              attrs: {
                label: _vm.$t("RouterObj.ReceivableAccount"),
                name: "ReceivableAccount",
                lazy: "",
              },
            },
            [
              _vm.activeName === "ReceivableAccount"
                ? _c(
                    "div",
                    [_c("ReceivableAccount", { ref: "ReceivableAccount" })],
                    1
                  )
                : _vm._e(),
            ]
          ),
          _c(
            "el-tab-pane",
            {
              attrs: {
                label: _vm.$t("RouterObj.CustomerAccount"),
                name: "CustomerAccount",
                lazy: "",
              },
            },
            [
              _vm.activeName === "CustomerAccount"
                ? _c(
                    "div",
                    [_c("CustomerAccount", { ref: "CustomerAccount" })],
                    1
                  )
                : _vm._e(),
            ]
          ),
          _c(
            "el-tab-pane",
            {
              attrs: {
                label: _vm.$t("RouterObj.BranchAccounts"),
                name: "BranchAccounts",
                lazy: "",
              },
            },
            [
              _vm.activeName === "BranchAccounts"
                ? _c(
                    "div",
                    [_c("BranchAccounts", { ref: "BranchAccounts" })],
                    1
                  )
                : _vm._e(),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }